import { IPatient, IPatientState } from 'entities/Patient/Patient.models';

export const patientReducers = {
  setPatient: (state: IPatientState, payload: IPatient | null) => ({ ...state, data: payload }),
  setLoading: (state: IPatientState, payload: boolean) => ({ ...state, loading: payload }),
};
